import type { VFC } from 'react'

import noop from 'shared/utils/noop'
import AuthHeader from 'views/components/organisms/CmsMobileMenu/AuthHeader'
import ItemList from 'views/components/organisms/CmsMobileMenu/ItemList'
import type { BodyProps } from 'views/components/organisms/CmsMobileMenu/types'
import LanguageSwitcherMobile from 'views/components/organisms/LanguageSwitcher/LanguageSwitcherMobile'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const Body: VFC<BodyProps> = ({
  categoryData,
  goNextHandler,
  isTopLevel,
  subscriptionService,
  userLoggedIn,
}) => {
  const { categories, bottomCategories, topCategories } = categoryData
  return (
    <div className="o-OffCanvasView__body">
      <AuthHeader
        subscriptionService={subscriptionService}
        userLoggedIn={userLoggedIn}
      />
      <LanguageSwitcherMobile />
      <ItemList
        goNextHandler={goNextHandler}
        isTopLevel={isTopLevel}
        items={topCategories.items}
        menu={topCategories}
        showCategoryTitle={false}
      />
      <ItemList
        goNextHandler={goNextHandler}
        isTopLevel={isTopLevel}
        items={categories.items}
        menu={categories}
        showCategoryTitle={false}
      />
      <ItemList
        className="u-margin-auto--top"
        goNextHandler={goNextHandler}
        isTopLevel={isTopLevel}
        items={bottomCategories.items}
        menu={bottomCategories}
        showCategoryTitle={false}
      />
    </div>
  )
}

Body.defaultProps = {
  goNextHandler: noop,
  isTopLevel: false,
  subscriptionService: false,
  userLoggedIn: false,
}

export default withMountPoints(withShopAndRuntimeConfig(Body))
